// Generated by ts-to-zod
import { z } from 'zod';
import { annotationSchema } from '../models/annotation.schema';

export const annotationPayloadSchema = annotationSchema.partial();
